import apiRoutes from '../../apiRoutes';
import { rootApi } from './index';

const filesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    upload: builder.mutation({
      query: (body) => ({
        url: apiRoutes.uploadFile(),
        method: 'POST',
        body,
      }),
    })
  })
});

export const {
  useUploadMutation,
} = filesApi;
